import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
/* eslint-disable global-require */
if (process.env.ISMOCK) {
  require('Mocks/pblManagement/pblManagement')
}

export async function callGetPbls(params) {
  let data
  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API_NO_PSP}payment-services/v3/orders/paybylink?${params?.rsqlString || {}}`,
      params: params.queryParams,
      headers: {
        tenantId: params.headers.tenantId,
        merchantId: params.headers.merchantId,
        roles: params.headers.roles
      }
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function deleteOrUpdateLink(params) {
  let data
  try {
    data = await axios({
      method: 'post',
      url: `${process.env.PHOENIX_API_NO_PSP}payment-services/v3/paybylink/${params.urlParams.linkId}/modify`,
      headers: {
        merchantId: params.headers.merchantId,
        tenantId: params.headers.tenantId,
        roles: params.headers.roles
      },
      data: { ...params.data }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callRetrievePblsExportFile({ format, queryParams, headers }) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API_NO_PSP}payment-services/paybylink/exports/${format}`,
      headers,
      params: queryParams,
      responseType: 'blob'
    })

    if (data.status === 400) {
      const promise = await data.data.text()
      return handlingResponse({ ...data, data: JSON.parse(promise) })
    }

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callGetPblDetail(params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API_NO_PSP}payment-services/v3/orders/paybylink/${params.urlParams.linkId}?pageSize=${params.queryParams?.pageSize}&page=${params.queryParams?.page}`,
      headers: params.headers,
      withCredentials: true
    })

    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function callPblVersionSettings(params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: `${process.env.PHOENIX_API_NO_PSP}payment-services/internal/v1/settings`,
      headers: params.headers,
      data: JSON.stringify({ ...params.payload })
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
